import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["terms", "template"]

  add(event) {
    event.preventDefault()
    const timestamp = new Date().getTime()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, timestamp)
    this.termsTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()
    const termWrapper = event.currentTarget.closest(".property-term")
    const destroyField = termWrapper.querySelector('input[name*="_destroy"]')

    if (destroyField) {
      destroyField.value = "1"
      termWrapper.style.display = "none"
    } else {
      termWrapper.remove()
    }
  }
}
